import React, { useState } from 'react';
import { Button, Input, Typography, message } from 'antd';

import { apiPHP } from '../../../../services/api';
import { apiErrorMessage, type GeneratorProps } from './types';

// Gerador de cruzada (POST /generate_crossword) do "+ Novo jogo" (quem anuncia o sucesso é o assistente). O
// registro criado é uma cruzada sem estilo — aparece como "Cruzada tradicional".

interface Item {
  palavra: string;
  dica: string;
}

interface GenerateCrosswordResponse {
  id: number;
  colocadas: string[];
  naoColocadas?: string[];
}

export const CrosswordGenerator: React.FC<GeneratorProps> = ({ resolveTitle, onCreated }) => {
  const [itens, setItens] = useState<Item[]>([
    { palavra: '', dica: '' },
    { palavra: '', dica: '' },
  ]);
  const [loading, setLoading] = useState(false);

  const setItem = (i: number, patch: Partial<Item>) =>
    setItens((arr) => arr.map((it, idx) => (idx === i ? { ...it, ...patch } : it)));

  const generate = async () => {
    const titulo = await resolveTitle();
    if (titulo === null) return;
    const payload = itens
      .map((it) => ({ palavra: it.palavra.trim(), dica: it.dica.trim() }))
      .filter((it) => it.palavra.length >= 2);
    if (payload.length === 0) {
      message.error('Adicione ao menos uma palavra (2+ letras).');
      return;
    }
    setLoading(true);
    try {
      const { data } = await apiPHP.post<GenerateCrosswordResponse>('/generate_crossword', {
        titulo,
        itens: payload,
      });
      if (data.naoColocadas?.length) {
        message.warning(`Não couberam (sem cruzamento): ${data.naoColocadas.join(', ')}`, 8);
      }
      onCreated(data.id);
    } catch (e: unknown) {
      message.error(apiErrorMessage(e, 'Falha ao gerar a cruzada.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Typography.Paragraph type="secondary">
        Digite palavras + dicas — o sistema encaixa elas cruzando umas nas outras. Algumas podem
        não caber (sem cruzamento); avisamos quais.
      </Typography.Paragraph>
      {itens.map((it, i) => (
        <div key={i} style={{ display: 'flex', gap: 8, marginTop: 8 }}>
          <Input
            style={{ flex: 1 }}
            value={it.palavra}
            onChange={(e) => setItem(i, { palavra: e.target.value })}
            placeholder={`Palavra ${i + 1}`}
          />
          <Input
            style={{ flex: 2 }}
            value={it.dica}
            onChange={(e) => setItem(i, { dica: e.target.value })}
            placeholder="Dica"
          />
        </div>
      ))}
      <div style={{ marginTop: 12 }}>
        <Button size="small" onClick={() => setItens((a) => [...a, { palavra: '', dica: '' }])}>
          + palavra
        </Button>{' '}
        <Button type="primary" loading={loading} onClick={generate}>
          Gerar cruzada
        </Button>
      </div>
    </div>
  );
};

export default CrosswordGenerator;
